var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4911",
    "data-name": "Group 4911",
    transform: "translate(-330 -752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble",
    transform: "translate(330 752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24,0V24H0V0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.44,4.67A39.323,39.323,0,0,0,4.56,0,8.521,8.521,0,0,0,0,5.74a16.887,16.887,0,0,0,6.74-.81C6.98,4.85,7.21,4.76,7.44,4.67Z",
    transform: "translate(3.72 4.37)",
    fill: "rgba(151,161,194,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.14,1.82A3.646,3.646,0,0,0,9,1.47C8.79.97,8.56.48,8.33,0c-.29.11-.58.23-.89.34a18.822,18.822,0,0,1-5.92.96c-.5,0-1-.03-1.5-.07-.01.13-.02.25-.02.38A8.515,8.515,0,0,0,1.74,6.75,15.706,15.706,0,0,1,6.42,2.91,15.924,15.924,0,0,1,9.14,1.82Z",
    transform: "translate(3.5 10.39)",
    fill: "rgba(151,161,194,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.28,0A8.6,8.6,0,0,0,0,.32,41.915,41.915,0,0,1,2.82,4.94,17.537,17.537,0,0,0,7.36,1.7,8.478,8.478,0,0,0,2.28,0Z",
    transform: "translate(9.72 3.5)",
    fill: "rgba(151,161,194,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,4.6A8.433,8.433,0,0,0,5.75,6.86a8.41,8.41,0,0,0,2.93-.53A39.221,39.221,0,0,0,6.95,0,13.979,13.979,0,0,0,4.36.99,14.123,14.123,0,0,0,0,4.6Z",
    transform: "translate(6.25 13.64)",
    fill: "#97a1c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1.65,6.223A8.512,8.512,0,0,0,5.7.343,15.282,15.282,0,0,0,0,.2,39.134,39.134,0,0,1,1.65,6.223Z",
    transform: "translate(14.67 13.087)",
    fill: "#97a1c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M.69,5.07c.08.2.15.4.23.6a16.782,16.782,0,0,1,6.38.05A8.448,8.448,0,0,0,4.99,0,18.787,18.787,0,0,1,0,3.58C.24,4.08.47,4.57.69,5.07Z",
    transform: "translate(13.2 6.2)",
    fill: "rgba(151,161,194,0.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.79139dac2699a34a4e76ac7cf3ec89b4.svg";
export { ForwardRef as ReactComponent };